import React from 'react';

import { Button } from 'widget/shared/ui/Button';

export type SubmitButtonProps = {
  label: string;
  disabled?: boolean;
  loading?: boolean;
  onClick: () => void;
};

const SubmitButton: React.FC<SubmitButtonProps> = ({
  label,
  disabled = false,
  loading = false,
  onClick
}) => {
  return (
    <Button fullWidth disabled={disabled} loading={loading} onClick={onClick}>
      {label}
    </Button>
  );
};

export default React.memo(SubmitButton);
